<template>
  <v-container>
    <template v-if="show && currentNotification.type_id === 7">
      <v-layout row wrap mb-3>
        <v-flex class="text-xs-center">
          <h1>
            Llamada entrante
          </h1>
        </v-flex>
      </v-layout>
      <template v-if="!noCustomer">
        <v-layout row wrap justify-center mb-3>
          <v-flex md4>
            <v-text-field
              v-model="fiscal_id"
              prepend-icon="fas fa-search"
              placeholder="Ingrese Rut"
              solo
              flat/>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex md4>
            <v-text-field
              v-model="customer_name"
              prepend-icon="fas fa-search"
              placeholder="Ingrese Nombre"
              solo
              flat/>
          </v-flex>
        </v-layout>
        <v-layout row wrap mt-2 mb-3>
          <v-flex offset-md4 md4>
            <a @click="noCustomer = true">
              No es cliente
            </a>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-4>
          <v-flex offset-md3 md6>
              <v-list
                class="elevation-0 py-0">
                <vue-perfect-scrollbar v-if="customers.length" class="scrollbar">
                  <template v-for="(item, i) in customers">
                    <v-list-tile
                      v-if="customerSelected === false"
                      :key="`customers-${item.id}`"
                      @click="selectCustomer(item)">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.fiscal_id }}
                          {{ item.name || (`${item.first_name} ${(item.last_name ? item.last_name : '')}`) }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile
                      v-else
                      :key="`customers-${item.id}`">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.fiscal_id }}
                          {{ item.name || (`${item.first_name} ${(item.last_name ? item.last_name : '')}`) }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider
                      v-if="i !== customers.length - 1"
                      :key="`divider${i}`"/>
                  </template>
                </vue-perfect-scrollbar>
                <v-list-tile
                  v-else
                  class="py-1 text-xs-center no-rows">
                  <v-icon class="mr-4">
                    fas fa-exclamation-circle
                  </v-icon>
                  <p class="mb-0">
                    No hay nada que mostrar
                  </p>
                </v-list-tile>
              </v-list>
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <v-layout row wrap mb-3>
          <v-flex offset-md4 md4>
            <v-text-field
              v-model="form.fiscal_id"
              color="black"
              prepend-icon="fas fa-id-card-alt"
              placeholder="RUT/DNI/CI"
              solo
              flat/>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-3>
          <v-flex offset-md4 md4>
            <v-text-field
              v-model="form.first_name"
              color="black"
              prepend-icon="fas fa-user"
              placeholder="Nombres"
              solo
              flat/>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-2>
          <v-flex offset-md4 md4>
            <v-text-field
              v-model="form.last_name"
              color="k-orange"
              prepend-icon="fas fa-user"
              placeholder="Apellidos"
              solo
              flat/>
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-2>
          <v-flex offset-md4 md4 class="text-xs-right">
            <a @click="noCustomer = false">
              Es cliente
            </a>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex offset-md4 md4 class="text-xs-right">
            <v-btn color="k-orange-linear" class="mr-0" @click="saveNoCustomer" :disabled="disableSaveButton">
              Guardar
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <call-center-dialer
        :notification="currentNotification"
        @mute="$store.dispatch('dialer/setMute', $event)"
        @hangup="$store.dispatch('dialer/hangup')"/>
    </template>
    <v-layout v-else-if="show && !extensions.length" row wrap class="center">
      <v-flex xs12 text-xs-center>
        <h1>
          <v-icon class="mr-2" large>
            fas fa-phone-volume
          </v-icon>
          Iniciando marcado...
        </h1>
      </v-flex>
    </v-layout>
    <v-layout v-else-if="show && extensions.length" row wrap mt-2>
      <v-flex xs12>
        <table>
          <thead>
            <th>
              Extension
            </th>
            <th>
              Cliente
            </th>
            <th>
              Telefono
            </th>
          </thead>
          <tbody>
            <tr v-for="item in extensions" :key="`extension-${item.extension}`">
              <td>
                {{ item.extension }}
              </td>
              <template v-if="item.status_id === 3">
                <td>
                  {{ item.current_call.full_name }}
                </td>
                <td>
                  {{ getPhone(item.current_call.phone) }}
                </td>
              </template>
              <td v-else colspan="2">
                Buscando deudor...
              </td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-layout>
    <v-snackbar
      :bottom="true"
      v-model="reconnecting"
      :timeout="0"
      top
      absolute>
      Perdida de conexion con el servidor de llamadas, reconectando...
    </v-snackbar>
  </v-container>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CallCenterDialer from '@/components/CallCenter/Dialer';
import EventBus from '@/event-bus';
import permissionsMixin from '@/mixins/permissions';

const routerHandler = (to, from, next) => {
  next((vm) => {
    if (
      !(
        vm.$store.state.dialer.callCenterStatus === 1
        || (
          vm.$store.state.dialer.callCenterStatus === 3
          && !vm.$store.state.dialer.notification.customer_id
        )
      )
    ) {
      let name = from.name || 'CallList';
      if (name === 'CallListWait') {
        name = 'CallList';
      }
      vm.$router.push({
        name,
      });
    } else {
      vm.show = true; // eslint-disable-line
    }
  });
};

export default {
  beforeRouteEnter: routerHandler,
  beforeRouteUpdate: routerHandler,
  beforeRouteLeave(to, from, next) {
    console.log('CALL CENTER STATUS', this.$store.state.dialer.callCenterStatus);
    console.log('TO ROUTE NAME', to.name);
    console.log('TO ROUTE', to);
    if (this.$store.state.dialer.callCenterStatus > 0 && to.name !== 'CustomerShow') {
      EventBus.$emit('modal', 'No puede abandonar esta pestaña mientras este conectado.');
      next(false);
    } else {
      next();
    }
  },
  mixins: [permissionsMixin],
  components: {
    VuePerfectScrollbar,
    CallCenterDialer,
  },
  created() {
    EventBus.$emit('hideMenu');
  },
  destroyed() {
    this.cancelToken.cancel('Canceled by user');
  },
  data() {
    const emptyForm = {
      fiscal_id: '',
      first_name: '',
      last_name: '',
    };
    return {
      show: false,
      customerSelected: false,
      noCustomer: false,
      fiscal_id: '',
      customer_name: '',
      customers: [],
      emptyForm,
      form: {
        ...emptyForm,
      },
      tmp_call_id: '',
      cancelToken: this.axios.CancelToken.source(),
    };
  },
  computed: {
    extensions() {
      return this.$store.state.dialer.extensions;
    },
    currentNotification() {
      return this.$store.state.dialer.notification || {};
    },
    reconnecting() {
      return this.$store.state.dialer.reconnecting || false;
    },
    disableSaveButton() {
      let disabled = true;
      Object.keys(this.form).forEach((key) => {
        disabled = disabled && String(this.form[key]).trim() === '';
      });
      return disabled;
    },
    canSeeMasked() {
      return this.checkPermissions([
        'see_masked_data',
      ]); 
    },
  },
  methods: {
    getPhone(phone) {
      let result = phone;
      if (!this.canSeeMasked && !phone.includes('*')) {
        const length = phone.length - 3;
        const chars = '*'.repeat(length);
        result = `${chars}${phone.slice(-3)}`;
      }
      return result;
    },
    selectCustomer(customer) {
      this.customerSelected = true;
      this.axios.post('/call_center/incoming_call/update', {
        phone: this.currentNotification.phone,
        timestamp: this.currentNotification.key.timestamp,
        customer_id: customer.id,
        fiscal_id: customer.fiscal_id,
        account: customer.account,
        full_name: customer.name || `${customer.first_name}${customer.last_name ? ` ${customer.last_name}` : ''}`,
        first_name: customer.first_name,
        last_name: customer.last_name,
      }).catch(() => {
        this.customerSelected = false;
        EventBus.$emit('error', 'Ocurrio un error, intente nuevamente');
      });
    },
    saveNoCustomer() {
      this.axios.post('/call_center/incoming_call/update', {
        phone: this.currentNotification.phone,
        timestamp: this.currentNotification.key.timestamp,
        fiscal_id: this.form.fiscal_id,
        full_name: this.form.name || `${this.form.first_name}${this.form.last_name ? ` ${this.form.last_name}` : ''}`,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
      }).catch(() => {
        EventBus.$emit('error', 'Ocurrio un error, intente nuevamente');
      });
    },
    getCustomers() {
      this.customers = [];
      this.cancelToken.cancel('Canceled by user');
      if (String(this.fiscal_id).trim() || String(this.customer_name).trim()) {
        this.cancelToken = this.axios.CancelToken.source();
        let filter = '';
        if (this.fiscal_id && this.customer_name) {
          filter = 'both';
        } else {
          if (this.fiscal_id) {
            filter = 'fiscal_id';
          } else {
            filter = 'name';
          }
        }
        this.axios.get('customers/v2', {
          params: {
            filter,
            search: this.fiscal_id,
            name: this.customer_name,
            paginate: 0,
          },
          cancelToken: this.cancelToken.token,
        }).then((response) => {
          this.customers = response.data;
        }).catch(() => {});
      }
    },
  },
  watch: {
    fiscal_id: _.debounce(function () { // eslint-disable-line
      this.getCustomers();
    }, 500),
    customer_name: _.debounce(function () { // eslint-disable-line
      this.getCustomers();
    }, 500),
    currentNotification() {
      if (this.tmp_call_id !== this.currentNotification.call_id) {
        this.form = {
          ...this.emptyForm,
        };
        this.noCustomer = false;
        this.fiscal_id = '';
        this.customers = [];
      }
      if (
        !this.currentNotification.customer_id
        && (
          this.currentNotification.full_name
          || this.currentNotification.fiscal_id
        )
      ) {
        this.form.fiscal_id = this.currentNotification.fiscal_id;
        this.form.first_name = this.currentNotification.first_name;
        this.form.last_name = this.currentNotification.last_name;
        this.noCustomer = true;
      }
      this.tmp_call_id = this.currentNotification.call_id;
    },
  },
};
</script>

<style scoped>
.center {
  margin-top: 25% !important;
}
table {
  width: 100%;
  border-collapse: collapse;
}
table thead th {
  text-align: center;
  background: #fff;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid #ff7c64;
}
table tbody td:first-child {
  padding-left: 15px;
}
table tbody td {
  background: #fff;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ddd;
  text-align: center;
}
.scrollbar {
  height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/Wait.vue